import React from 'react'
import style from './style.module.scss'
import UserMenu from './UserMenu'

const TopBar = () => {
  return (
    <div className={style.topbar}>
      <div className="ml-auto">
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
